module.exports = __webpack_public_path__ + "img/thinking_panda1.c0f093d5.gif";